
export const zonas= [
    {codigo: 0, nombre: "NO DEFINIDA"},
    {codigo: 1, nombre: "MESIAL"},
    {codigo: 2, nombre: "DISTAL"},
    {codigo: 3, nombre: "OCLUSAL"},
    {codigo: 4, nombre: "MOD"},
    {codigo: 5, nombre: "LINGUAL"},
    {codigo: 6, nombre: "PALATINO"},
    {codigo: 7, nombre: "CERVICAL"},
    {codigo: 8, nombre: "INCISAL"},
    {codigo: 9, nombre: "SUPERIOR"},
    {codigo: 10, nombre: "INFERIOR"},

];

export const dientes= [
    {codigo: 0, nombre: "NO DEFINIDA"},

    {codigo: 11, nombre: "11 CENTRAL SUPERIOR"},
    {codigo: 12, nombre: "12 LATERAL SUPERIOR"},
    {codigo: 13, nombre: "13 CANINO SUPERIOR"},
    {codigo: 14, nombre: "14 PREMOLAR SUPERIOR"},
    {codigo: 15, nombre: "15 PREMOLAR SUPERIOR"},
    {codigo: 16, nombre: "16 MOLAR SUPERIOR"},
    {codigo: 17, nombre: "17 MOLAR SUPERIOR"},
    {codigo: 18, nombre: "18 CORDAL SUPERIOR"},

    {codigo: 21, nombre: "21 CENTRAL SUPERIOR"},
    {codigo: 22, nombre: "22 LATERAL SUPERIOR"},
    {codigo: 23, nombre: "23 CANINO SUPERIOR"},
    {codigo: 24, nombre: "24 PREMOLAR SUPERIOR"},
    {codigo: 25, nombre: "25 PREMOLAR SUPERIOR"},
    {codigo: 26, nombre: "26 MOLAR SUPERIOR"},
    {codigo: 27, nombre: "27 MOLAR SUPERIOR"},
    {codigo: 28, nombre: "28 CORDAL SUPERIOR"},

    {codigo: 31, nombre: "31 CENTRAL INFERIOR"},
    {codigo: 32, nombre: "32 LATERAL INFERIOR"},
    {codigo: 33, nombre: "33 CANINO INFERIOR"},
    {codigo: 34, nombre: "34 PREMOLAR INFERIOR"},
    {codigo: 35, nombre: "35 PREMOLAR INFERIOR"},
    {codigo: 36, nombre: "36 MOLAR INFERIOR"},
    {codigo: 37, nombre: "37 MOLAR INFERIOR"},
    {codigo: 38, nombre: "38 CORDAL INFERIOR"},

    {codigo: 41, nombre: "41 CENTRAL INFERIOR"},
    {codigo: 42, nombre: "42 LATERAL INFERIOR"},
    {codigo: 43, nombre: "43 CANINO INFERIOR"},
    {codigo: 44, nombre: "44 PREMOLAR INFERIOR"},
    {codigo: 45, nombre: "45 PREMOLAR INFERIOR"},
    {codigo: 46, nombre: "46 MOLAR INFERIOR"},
    {codigo: 47, nombre: "47 MOLAR INFERIOR"},
    {codigo: 48, nombre: "48 CORDAL INFERIOR"},

    {codigo: 51, nombre: "51 CENTRAL SUPERIOR"},
    {codigo: 52, nombre: "52 LATERAL SUPERIOR"},
    {codigo: 53, nombre: "53 CANINO SUPERIOR"},
    {codigo: 54, nombre: "54 MOLAR SUPERIOR"},
    {codigo: 55, nombre: "55 MOLAR SUPERIOR"},

    {codigo: 61, nombre: "61 CENTRAL SUPERIOR"},
    {codigo: 62, nombre: "62 LATERAL SUPERIOR"},
    {codigo: 63, nombre: "63 CANINO SUPERIOR"},
    {codigo: 64, nombre: "64 MOLAR SUPERIOR"},
    {codigo: 65, nombre: "65 MOLAR SUPERIOR"},

    {codigo: 71, nombre: "71 CENTRAL INFERIOR"},
    {codigo: 72, nombre: "72 LATERAL INFERIOR"},
    {codigo: 73, nombre: "73 CANINO INFERIOR"},
    {codigo: 74, nombre: "74 MOLAR INFERIOR"},
    {codigo: 75, nombre: "75 MOLAR INFERIOR"},

    {codigo: 81, nombre: "81 CENTRAL INFERIOR"},
    {codigo: 82, nombre: "82 LATERAL INFERIOR"},
    {codigo: 83, nombre: "83 CANINO INFERIOR"},
    {codigo: 84, nombre: "84 MOLAR INFERIOR"},
    {codigo: 85, nombre: "85 MOLAR INFERIOR"},

];

export const tiposPagos= [
    {codigo: 0, nombre: "NO DEFINIDO"},
    {codigo: 1, nombre: "TARJETA"},
    {codigo: 2, nombre: "EFECTIVO"},
    {codigo: 3, nombre: "TRANSFERENCIA"},
    {codigo: 4, nombre: "FINANCIACIÓN"},
];

export const citaavisoestados= [
    {codigo: 0, nombre: "NO DEFINIDO"},
    {codigo: 1, nombre: "AVISADO"},
    {codigo: 2, nombre: "NO CONTESTA"},
    {codigo: 3, nombre: "WHATSAPP"},
    {codigo: 4, nombre: "WHATSAPP CONFIRMADO"},
];

export const salaesperaestados= [
    {codigo: 0, nombre: "NO DEFINIDO"},
    {codigo: 1, nombre: "ESPERANDO"},
    {codigo: 2, nombre: "EN GABINETE"},
    {codigo: 3, nombre: "ESPERANDO ANESTESIA"},
    {codigo: 4, nombre: "ESPERANDO DESPACHO"},
    {codigo: 5, nombre: "DESPACHO"},
    {codigo: 6, nombre: "FUERA"},
];